// record-stamp.js — createdAt / updatedAt for CRM rows.
//
// The stamp is taken at the moment of the edit. Queues, retries, boot-merge,
// applying a WS update, and atomic confirmations must NOT recompute it: the
// original intent time is what LWW compares. New ids (duplicate / copy) get
// stampNewRecord() — they are new rows, not heirs of the original timestamps.

import { serverNow } from './server-clock.js';

// A stamp more than a minute ahead of the estimate is poison (sticky future
// that later edits inherit as prev+1 and then lose LWW on the server).
// Clock-estimate lag of hundreds of ms–seconds is still inherited.
export const FUTURE_SLACK_MS = 60_000;
const warnedFuture = new Set();

// ISO strings and other non-numerics become 0 — same contract as stampUpdate.
export function coerceStamp(v) {
  const p = Number(v);
  return Number.isFinite(p) ? p : 0;
}

export function recordNow() {
  return Math.round(serverNow());
}

export function stampNewRecord() {
  const n = recordNow();
  return { createdAt: n, updatedAt: n };
}

export function stampUpdate(prevUpdatedAt) {
  const now = recordNow();
  const prev = coerceStamp(prevUpdatedAt);
  if (prev > now + FUTURE_SLACK_MS) {
    if (!warnedFuture.has(prev)) {
      warnedFuture.add(prev);
      console.warn('[record-stamp] dropping future updatedAt', prev, '→', now);
    }
    return now;
  }
  return Math.max(now, prev + 1);
}

export function _resetRecordStamp() {
  warnedFuture.clear();
}
